// 事前審査結果確認（不承認）（ステータス92050）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import FooterPreliminaryExaminationResultConfirmationDisapproval from '../../organisms/FooterPreliminaryExaminationResultConfirmationDisapproval';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  opened_mypage: boolean;
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  show_error_nav: boolean;
  guarantor_info: GuarantorInfo;
}

const PreliminaryExaminationResultConfirmationDisapproval: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  opened_mypage,
  guarantors_num,
  is_loading,
  display_status,
  show_error_nav,
  guarantor_info,
}) => {
  return (
    <>
      <TopArea
        step_navigation={opened_mypage ? { ...step_navigation, show: false } : step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={async () => {}}
        guarantor_info={guarantor_info}
      />
      <FooterPreliminaryExaminationResultConfirmationDisapproval
        mypage_opened={opened_mypage}
        is_login={true}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default PreliminaryExaminationResultConfirmationDisapproval;
